import { cn } from "../v2/utils";
import { jsx as _jsx } from "react/jsx-runtime";
var Loader = function Loader(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 1.8 : _ref$duration,
    itemClass = _ref.itemClass,
    className = _ref.className;
  var KLOADER_SIZE = {
    xs: 'tw-h-1.6 tw-w-1.6',
    s: 'tw-h-3.2 tw-w-3.2',
    m: 'tw-h-4.8 tw-w-4.8'
  };
  var KLOADER_ITEM = {
    a: 'tw-loader-item-a',
    b: 'tw-loader-item-b',
    c: 'tw-loader-item-c',
    d: 'tw-loader-item-d',
    e: 'tw-loader-item-e',
    f: 'tw-loader-item-f',
    g: 'tw-loader-item-g',
    h: 'tw-loader-item-h'
  };
  return /*#__PURE__*/_jsx("span", {
    id: "tw-crehana-loader",
    "data-testid": "crehana-loader",
    className: cn(KLOADER_SIZE[size], className),
    children: Object.keys(KLOADER_ITEM).map(function (loaderId) {
      return /*#__PURE__*/_jsx("span", {
        id: KLOADER_ITEM[loaderId],
        style: {
          animationDuration: "".concat(duration, "s")
        },
        className: itemClass || 'tw-bg-primary-light-500 dark:tw-bg-neutral-light-100'
      }, KLOADER_ITEM[loaderId]);
    })
  });
};
export default Loader;